module.exports = __webpack_public_path__ + "img/forestgreen.1d13f29.jpg";